import Vue from "vue"
import App from "./App.vue"
import "./registerServiceWorker"
import router from './router'

Vue.config.productionTip = false

window.app = new Vue({
    render: h => h(App),
    router,

    data: {
		artist: "broken but ok",
		social: {
			facebook: "dmdbbok",
			instagram: "dmdbbok",
			twitter: "dmdbbok",
			youtube: false
		}
	}
}).$mount("#app")
